<div class="dash">

  <!-- WYLACZNIK AWARYJNY (27.08): pulpit odciety od backendu na czas prac
       serwerowych. Komunikat zamiast pustej strony, zeby nikt nie zglaszal
       tego jako kolejnej awarii. Patrz DASHBOARD_ENABLED w .ts -->
  <div class="dash-off" *ngIf="disabled">
    <h1>{{ 'HOME.TITLE' | translate }}</h1>
    <p>Pulpit jest w tej chwili udostępniony wybranym osobom — wracamy nim
       po awarii etapami i sprawdzamy obciążenie serwera. Pozostałe zakładki
       panelu działają normalnie.</p>
  </div>

  <!-- nagłówek -->
  <div class="dash-head" *ngIf="!disabled">
    <h1>{{ 'HOME.TITLE' | translate }}</h1>
    <input type="date" class="date-input"
           [value]="selectedDate" [min]="minDate" [max]="maxDate"
           (change)="onDateChange($any($event.target).value)">
    <button type="button" class="today-btn" *ngIf="!data?.isToday" (click)="goToday()">{{ 'HOME.TODAY_BTN' | translate }}</button>
    <span class="sp"></span>
    <span class="weekend-badge" *ngIf="data?.weekendPreview as wp" [title]="'HOME.WEEKEND_PREVIEW_HINT' | translate">
      {{ 'HOME.WEEKEND_PREVIEW' | translate: { monday: (wp.monday | date: 'dd.MM') } }}
    </span>
    <span class="asof" *ngIf="data">
      <i class="live" *ngIf="data.isToday"></i>
      {{ 'HOME.AS_OF' | translate }} {{ generatedTime }}
      · {{ 'HOME.CUTOFF_HINT' | translate: { b2b: data.cutoffs.b2b, b2c: data.cutoffs.b2c } }}
    </span>
  </div>

  <ng-container *ngIf="data">

    <!-- górny rząd: liczby / łuk postępu / statusy -->
    <div class="top">

      <div class="card nums">
        <div>
          <span class="lbl">{{ 'HOME.TILE_TOTAL' | translate }}</span>
          <div class="big">
            <span class="big-num">{{ displayTotal }}</span>
            <span class="big-side">
              <span class="lbl" *ngIf="combinedFromPrevDay > 0">{{ 'HOME.OF_WHICH' | translate }}</span>
              <small *ngIf="combinedFromPrevDay > 0">{{ todayOnly }} {{ 'HOME.TODAY_NEW' | translate }}<br>+ {{ combinedFromPrevDay }} {{ 'HOME.TILE_FROM_PREV' | translate }}</small>
            </span>
          </div>
        </div>
        <div class="duo">
          <div class="duo-card duo-b2c">
            <span class="lbl">B2C</span>
            <span class="duo-num">{{ data.b2c.total }}</span>
            <span class="duo-meta">
              {{ 'HOME.CHANNELS_META' | translate: { n: nonZeroChannels.length } }}
              <ng-container *ngIf="data.b2c.lastWeekTotal > 0"> · {{ 'HOME.LAST_WEEK' | translate }} {{ data.b2c.lastWeekTotal }}
                <b [class.up]="delta(data.b2c) >= 0">{{ delta(data.b2c) >= 0 ? '+' : '' }}{{ delta(data.b2c) }}</b>
              </ng-container>
            </span>
          </div>
          <div class="duo-card duo-b2b">
            <span class="lbl">B2B</span>
            <span class="duo-num">{{ data.b2b.total }}</span>
            <span class="duo-meta">
              {{ 'HOME.MANAGERS_META' | translate: { n: data.b2b.managers?.length ?? 0 } }}
              <ng-container *ngIf="data.b2b.lastWeekTotal > 0"> · {{ 'HOME.LAST_WEEK' | translate }} {{ data.b2b.lastWeekTotal }}
                <b [class.up]="delta(data.b2b) >= 0">{{ delta(data.b2b) >= 0 ? '+' : '' }}{{ delta(data.b2b) }}</b>
              </ng-container>
            </span>
          </div>
          <div class="duo-card duo-svc" *ngIf="data.service?.total">
            <span class="lbl">{{ 'HOME.SERVICE' | translate }}</span>
            <span class="duo-num">{{ data.service.total }}</span>
            <span class="duo-meta">{{ 'HOME.SERVICE_META' | translate }}</span>
          </div>
        </div>
        <div class="nums-foot" *ngIf="data.isToday && combinedAfterCutoff > 0">
          {{ 'HOME.TILE_AFTER_CUTOFF' | translate }}: <b>{{ combinedAfterCutoff }}</b>
        </div>
      </div>

      <div class="card gauge">
        <span class="lbl">{{ 'HOME.PROGRESS' | translate }}</span>
        <div class="gauge-wrap">
          <svg viewBox="0 0 200 112">
            <path class="g-track" d="M20,100 A80,80 0 0 1 180,100"></path>
            <path class="g-val g-ready" d="M20,100 A80,80 0 0 1 180,100"
                  [style.stroke-dashoffset]="dashOffset(gaugeDash, gaugeClosedP)"></path>
            <path class="g-val g-shipped" d="M20,100 A80,80 0 0 1 180,100"
                  [style.stroke-dashoffset]="dashOffset(gaugeDash, gaugeShippedP)"></path>
          </svg>
          <div class="gauge-mid">
            <div class="gauge-pct">{{ progressPct }}%</div>
            <div class="gauge-cap">{{ 'HOME.CLOSED_OF' | translate: { done: closedCount, total: progressDenom } }}</div>
          </div>
        </div>
        <div class="legend">
          <span><i class="sw-shipped"></i>{{ 'HOME.LEGEND_SHIPPED' | translate }} {{ combined('shipped') }}</span>
          <span><i class="sw-ready"></i>{{ 'HOME.LEGEND_READY' | translate }} {{ combined('ready') }}</span>
          <span><i class="sw-progress"></i>{{ 'HOME.LEGEND_IN_PROGRESS' | translate }} {{ combined('inProgress') }}</span>
          <span><i class="sw-pending"></i>{{ 'HOME.LEGEND_PENDING' | translate }} {{ combined('pending') }}</span>
        </div>
      </div>

      <div class="card stat">
        <div class="st-row" *ngFor="let row of statRows; index as i">
          <div class="st-ring">
            <svg viewBox="0 0 56 56">
              <circle class="t" cx="28" cy="28" r="24"></circle>
              <circle class="v" cx="28" cy="28" r="24"
                      [style.stroke]="row.color"
                      [style.stroke-dashoffset]="dashOffset(ringDash, row.p)"
                      [style.transition-delay]="(i * 0.1) + 's'"></circle>
            </svg>
            <span class="st-num">{{ row.count }}</span>
          </div>
          <div>
            <div class="st-name">{{ row.labelKey | translate }}</div>
            <div class="st-sub">{{ row.subKey | translate }}</div>
          </div>
          <span class="st-pct">{{ pct(row.p) }}%</span>
        </div>
        <div class="st-row late clickable" *ngIf="combinedBacklog > 0" (click)="backlogOpen = !backlogOpen">
          <div class="st-ring">
            <svg viewBox="0 0 56 56">
              <circle class="t" cx="28" cy="28" r="24"></circle>
              <circle class="v v-late" cx="28" cy="28" r="24"
                      [style.stroke-dashoffset]="dashOffset(ringDash, 1)"></circle>
            </svg>
            <span class="st-num">{{ combinedBacklog }}</span>
          </div>
          <div>
            <div class="st-name">{{ 'HOME.TILE_BACKLOG' | translate }}</div>
            <div class="st-sub">{{ 'HOME.BACKLOG_SUB' | translate }}</div>
          </div>
          <span class="chev" [class.open]="backlogOpen">▾</span>
        </div>
        <div class="exp-list" *ngIf="backlogOpen && combinedBacklog > 0">
          <a class="exp-row" *ngFor="let o of backlogList" [href]="orderHref(o.id)" target="_blank" rel="noopener">
            <span class="exp-id">#{{ o.id }}</span>
            <span class="exp-side" [class.b2b]="o.side === 'B2B'">{{ o.side }}</span>
            <span class="exp-label">{{ o.label }}</span>
            <span class="exp-age">{{ o.date }} · {{ 'HOME.DAYS_OLD' | translate: { d: daysOld(o.date) } }}</span>
            <span class="exp-bucket">{{ bucketKey(o.bucket) | translate }}</span>
          </a>
          <p class="exp-more" *ngIf="combinedBacklog > backlogList.length">+ {{ combinedBacklog - backlogList.length }}</p>
        </div>
        <div class="issues-chip clickable" *ngIf="combinedIssues > 0" (click)="issuesOpen = !issuesOpen">
          ⚠ {{ 'HOME.TILE_ISSUES' | translate }}: <b>{{ combinedIssues }}</b>
          <span class="chev" [class.open]="issuesOpen">▾</span>
        </div>
        <div class="exp-list" *ngIf="issuesOpen && combinedIssues > 0">
          <a class="exp-row" *ngFor="let o of issuesList" [href]="orderHref(o.id)" target="_blank" rel="noopener">
            <span class="exp-id">#{{ o.id }}</span>
            <span class="exp-side" [class.b2b]="o.side === 'B2B'">{{ o.side }}</span>
            <span class="exp-label">{{ o.label }}</span>
            <span class="exp-bucket warn">
              <ng-container *ngIf="o.importError">{{ 'HOME.ISSUE_IMPORT' | translate }}</ng-container>
              <ng-container *ngIf="o.importError && o.toClarify"> · </ng-container>
              <ng-container *ngIf="o.toClarify">{{ 'HOME.ISSUE_CLARIFY' | translate }}</ng-container>
            </span>
          </a>
        </div>
      </div>
    </div>

    <!-- spływ godzinowy i realizacja -->
    <div class="card flow">
      <div class="ph">
        <h2>{{ 'HOME.FLOW_TITLE' | translate }}</h2>
        <span class="sub">{{ 'HOME.FLOW_SUB' | translate }}</span>
      </div>

      <div class="flow-scroll">
        <!-- Pula startowa: stos, z ktorym magazyn zaczyna dzien (niespakowane
             z poprzedniego dnia roboczego). Poza skala slupkow godzinowych,
             zeby nie splaszczyc wykresu. -->
        <div class="flow-body">
          <div class="startpool" *ngIf="flow"
               [class.empty]="flow.startPool.total === 0"
               [class.done]="flow.startPool.total > 0 && flow.startPool.open === 0"
               [title]="startPoolTitle">
            <span class="sp-lbl">{{ 'HOME.FLOW_STARTPOOL' | translate }}</span>
            <span class="sp-num">
              {{ flow.startPool.open }}<em *ngIf="flow.startPool.total">/{{ flow.startPool.total }}</em>
            </span>
            <span class="sp-sub" *ngIf="flow.startPool.total">{{ 'HOME.FLOW_STARTPOOL_LEFT' | translate }}</span>
            <!-- zapelnianie: ile z puli juz przerobione -->
            <div class="sp-bar" *ngIf="flow.startPool.total">
              <i [style.width.%]="startPoolPct"></i>
            </div>
            <span class="sp-sub">{{ 'HOME.FLOW_STARTPOOL_SUB' | translate: { date: flow.startPool.date } }}</span>
          </div>
          <div class="flow-chart">
        <div class="cols">
          <div class="col" *ngFor="let h of flowHours; index as i"
               [class.now]="data.isToday && h.hour === flow!.nowHour"
               [class.prev]="h.prevDay"
               [class.pre]="isBeforeCutoff(h)"
               [attr.data-now]="data.isToday && h.hour === flow!.nowHour ? ('HOME.NOW' | translate) + ' ' + flow!.nowLabel : null">
            <span class="mk" *ngIf="showHourMark(h)">{{ hourTotal(h) }}</span>
            <span class="cut" *ngIf="cutoffHour !== null && h.hour === cutoffHour">
              <span>{{ 'HOME.FLOW_CUTOFF_MARK' | translate: { h: cutoffHour } }}</span>
            </span>
            <div class="tb c" *ngIf="h.b2c.total > 0"
                 [style.height.%]="barHeight(h.b2c)"
                 [style.animation-delay]="(i * 0.03) + 's'"
                 [title]="barTitle(h, 'b2c')">
              <i class="op" *ngIf="h.b2c.open > 0" [style.flex]="h.b2c.open"></i>
              <i class="dn" *ngIf="h.b2c.total - h.b2c.open > 0" [style.flex]="h.b2c.total - h.b2c.open"></i>
            </div>
            <div class="tb bb" *ngIf="h.b2b.total > 0"
                 [style.height.%]="barHeight(h.b2b)"
                 [style.animation-delay]="(i * 0.03) + 's'"
                 [title]="barTitle(h, 'b2b')">
              <i class="op" *ngIf="h.b2b.open > 0" [style.flex]="h.b2b.open"></i>
              <i class="dn" *ngIf="h.b2b.total - h.b2b.open > 0" [style.flex]="h.b2b.total - h.b2b.open"></i>
            </div>
          </div>
        </div>

        <div class="hours">
          <span *ngFor="let h of flowHours">{{ h.hour % 2 === 0 ? (h.hour < 10 ? '0' + h.hour : h.hour) : '' }}</span>
        </div>


        <div class="striplbl">
          {{ 'HOME.FLOW_STRIP_LABEL' | translate }}
          <b>{{ 'HOME.FLOW_STRIP_HINT' | translate }}</b>
        </div>
        <div class="strip">
          <i *ngFor="let h of flowHours" [ngClass]="stripClass(h)" [title]="barTitle(h, 'b2c')">{{ stripLabel(h) }}</i>
        </div>
          </div>
        </div>
      </div>

      <div class="cutbar">
        <label for="flowCutoff">{{ 'HOME.FLOW_CUTOFF_LABEL' | translate }}</label>
        <select id="flowCutoff" [value]="cutoffValue" (change)="onCutoffChange($any($event.target).value)">
          <option *ngFor="let c of cutoffOptions" [value]="c">{{ c }}:00</option>
          <option value="none">{{ 'HOME.FLOW_CUTOFF_NONE' | translate }}</option>
        </select>
        <span class="res" *ngIf="cutoffHour !== null">
          <span>{{ 'HOME.FLOW_RES_BEFORE' | translate }} <b>{{ flowSummary.before }}</b></span>
          <span>{{ 'HOME.FLOW_RES_DONE' | translate }} <b>{{ flowSummary.done }}</b></span>
          <span>{{ 'HOME.FLOW_RES_OPEN' | translate }} <b [class.neg]="flowSummary.open > 0">{{ flowSummary.open }}</b></span>
        </span>
        <span class="res" *ngIf="cutoffHour === null">
          <span>{{ 'HOME.FLOW_RES_NO_CUTOFF' | translate: { n: flowSummary.openAll } }}</span>
        </span>
      </div>

      <div class="legend flow-legend">
        <span><i class="sw-b2c"></i>{{ 'HOME.FLOW_LEG_B2C' | translate }}</span>
        <span><i class="sw-b2b"></i>{{ 'HOME.FLOW_LEG_B2B' | translate }}</span>
        <span><i class="sw-open"></i>{{ 'HOME.FLOW_LEG_OPEN' | translate }}</span>
        <span><i class="sw-late"></i>{{ 'HOME.FLOW_LEG_LATE' | translate }}</span>
        <span *ngIf="data.isToday"><i class="sw-now"></i>{{ 'HOME.NOW' | translate }} {{ flow?.nowLabel }}</span>
        <span *ngIf="cutoffHour !== null"><i class="sw-cut"></i>{{ 'HOME.FLOW_LEG_CUTOFF' | translate }}</span>
      </div>
    </div>

    <!-- dolny rząd: kanały B2C / opiekunowie B2B -->
    <div class="bottom">

      <div class="card panel">
        <div class="ph">
          <h2>{{ 'HOME.B2C_TITLE' | translate }} · {{ data.b2c.total }}</h2>
          <span class="sub" *ngIf="data.b2c.lastWeekTotal > 0">{{ 'HOME.LAST_WEEK' | translate }}: {{ data.b2c.lastWeekTotal }}</span>
        </div>
        <div class="lolli" *ngFor="let ch of nonZeroChannels; index as i" [title]="channelTitle(ch)">
          <span class="lolli-name">{{ ch.name }}</span>
          <div class="lolli-line">
            <div class="lolli-fill" [style.width.%]="(ch.total / maxChannelTotal) * 100" [style.animation-delay]="(i * 0.04) + 's'"></div>
            <div class="dotm" [style.left.%]="(ch.total / maxChannelTotal) * 100"></div>
          </div>
          <span class="lolli-val">{{ ch.total }}</span>
        </div>
        <p class="empty" *ngIf="!nonZeroChannels.length">{{ 'HOME.EMPTY_DAY' | translate }}</p>
        <div class="zeros" *ngIf="zeroChannels.length">
          <span class="t">{{ 'HOME.ZEROS_LABEL' | translate }}</span>
          <span class="chip0" *ngFor="let ch of zeroChannels">{{ ch.name }}</span>
        </div>
      </div>

      <div class="card panel" *ngIf="data.service?.total">
        <div class="ph">
          <h2>{{ 'HOME.SERVICE_TITLE' | translate }} · {{ data.service.total }}</h2>
        </div>
        <div class="lolli" *ngFor="let ch of data.service.channels; index as i">
          <span class="lolli-name">{{ ch.name }}</span>
          <div class="lolli-line">
            <div class="lolli-fill" [style.width.%]="(ch.total / data.service.total) * 100"></div>
            <div class="dotm" [style.left.%]="(ch.total / data.service.total) * 100"></div>
          </div>
          <span class="lolli-val">{{ ch.total }}</span>
        </div>
      </div>

      <div class="card panel">
        <div class="ph">
          <h2>{{ 'HOME.B2B_TITLE' | translate }} · {{ data.b2b.total }}</h2>
          <span class="sub" *ngIf="data.b2b.lastWeekTotal > 0">{{ 'HOME.LAST_WEEK' | translate }}: {{ data.b2b.lastWeekTotal }}</span>
        </div>
        <div class="mgr">
          <div class="mgr-card" *ngFor="let m of data.b2b.managers">
            <span class="mgr-num" [class.zero]="m.total === 0">{{ m.total }}</span>
            <div>
              <div class="mgr-name">{{ managerLabel(m.login) }}</div>
              <div class="bar">
                <ng-container *ngIf="m.total > 0">
                  <div class="seg s-shipped" [style.width.%]="(m.shipped / m.total) * 100"></div>
                  <div class="seg s-ready" [style.width.%]="(m.ready / m.total) * 100"></div>
                  <div class="seg s-progress" [style.width.%]="(m.inProgress / m.total) * 100"></div>
                  <div class="seg s-pending" [style.width.%]="(m.pending / m.total) * 100"></div>
                </ng-container>
              </div>
              <div class="mgr-meta" *ngIf="m.total > 0">{{ m.shipped + m.ready }} / {{ m.total - m.cancelled }} {{ 'HOME.MANAGER_DONE' | translate }}</div>
              <div class="mgr-meta" *ngIf="m.total === 0">{{ 'HOME.NO_ORDERS_TODAY' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <p class="empty" *ngIf="!data && !loading">{{ 'HOME.LOAD_ERROR' | translate }}</p>
</div>
